import React, {useState} from "react";

import Header from "../components/section/header";
import Footer from "../components/section/footer";
import {Col, Modal, Row} from "react-bootstrap";
import Main from "../components/main";
import {getCurrentUserQuery} from "../components/logic/user";
import { useQuery } from "@apollo/client";
import Loader from "../components/bootstrap/loader";
import "../style/custom/recover-password.scss";
import ForgotPassword from "../components/forgot-password/index";
import config from "../config";
import ChangePassword from "../components/forgot-password/change-password";

export default function ForgotPasswordPage(props) {
  return (<Main>
    <UserCheck {...props} />
  </Main>);
}

const UserCheck = (props) => {
  const currentUserQuery = useQuery(getCurrentUserQuery);
  if (currentUserQuery.loading) {
    return <Loader />;
  }
  const user = currentUserQuery?.data?.classMethods?.User?.getCurrentUser;
  if (user) {
    window.location = `${config.portal}`;
    return (<React.Fragment/>);
  }

  return (
    <RecoverPasswordPage {...props} />
  );
};

const RecoverPasswordPage = () => {
  const [showForgotRequested, setShowForgotRequested] = useState(false);
  const params = new URLSearchParams(location.search);
  const verificationCode = params.get("v");

  return (
    <Main>

      <Header />
      <div className="recover-password">
        <div className="recover-password-inner">
          <div className="section-1">
            {verificationCode ? <ChangePassword/> : <Row className="vw-fs">
              <Col xs={12} sm={4} md={4} lg={4} className="vw-fs-section">
                {!showForgotRequested && <div className="sub-section-1">
                  <div className="vw-brand-elements">
                    <p className="vw-brand-tagline">{"Forgot Password?"}</p>
                    <p className="vw-brand-description">
                      {"Enter the email you use to register, and we'll help you create a new password."}
                    </p>
                  </div>
                </div>}
                <div className="vw-fp-panel">
                  <Row>
                    <Col xs={12} className="vw-form">
                      <ForgotPassword
                        showForgotRequested={showForgotRequested}
                        setShowForgotRequested={setShowForgotRequested}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>}
          </div>
          <Footer colour="black" />
        </div>
      </div>
    </Main>
  );
};


